// @ts-nocheck
import * as React from 'react';
import $ from 'jquery';

import batterycritical from '../images/battery-critical.svg';
import batterylow from '../images/battery-low.svg';
import batterynormal from '../images/battery-normal.svg';

import PlugSolid from '../images/PlugSolid.svg';
import UnPlug from '../images/Unplug.svg';

import TripInprogress from '../images/Status/RouteDeviation/TripInprogress.png';
import TripCompletedDeviation from '../images/Status/RouteDeviation/TripCompletedDeviation.png';
import TripCompleted from '../images/Status/RouteDeviation/TripCompleted.png';
import TripProblemetic from '../images/Status//RouteDeviation/TripProblemetic.png';
import TripPending from '../images/Status/RouteDeviation/TripPending.png';
import TripDeleted from '../images/Status/RouteDeviation/TripDeleted.png';
import TripCancelDeviation from '../images/Status/RouteDeviation/TripCancelDeviation.png';
import TripCancel from '../images/Status/RouteDeviation/TripCancel.png';
import AssetStateActive from '../images/AssetState/ActiveRA.svg';
import AssetStateDisconnected from '../images/AssetState/DisconnectedRA.png';
import AssetStateRetired from '../images/AssetState/RetiredRA.svg';

import RSSIUNK from '../images/RSSI/RSSI_UNK.png';
import RSSI1 from '../images/RSSI/RSSI_1.png';
import RSSI2 from '../images/RSSI/RSSI_2.png';
import RSSI3 from '../images/RSSI/RSSI_3.png';
import RSSI4 from '../images/RSSI/RSSI_4.png';
import RSSI5 from '../images/RSSI/RSSI_5.png';

import DBP0 from '../images/DoorBattPct/0.svg';
import DBP10 from '../images/DoorBattPct/10.svg';
import DBP20 from '../images/DoorBattPct/20.svg';
import DBP30 from '../images/DoorBattPct/30.svg';
import DBP40 from '../images/DoorBattPct/40.svg';
import DBP50 from '../images/DoorBattPct/50.svg';
import DBP60 from '../images/DoorBattPct/60.svg';
import DBP70 from '../images/DoorBattPct/70.svg';
import DBP80 from '../images/DoorBattPct/80.svg';
import DBP90 from '../images/DoorBattPct/90.svg';
import DBP100 from '../images/DoorBattPct/100.svg';
import DamageCheck from '../images/Possibledamage.svg';
import clearDamage from '../images/ClearPD.svg';

import GroupChat from '../images/GroupChat.png';

export class DryCellRenderer extends React.Component {
    constructor(props: any) {
        super(props);
    }

    static PwrStateFormatter(params) {
        if (params.data != null && params.data != undefined) {
            if (params.data.DryPWR != null && params.data.DryPWR != undefined) {               

                if (params.data.DryPWR.toString().toUpperCase().trim() == "A") {
                    return <span className="pwr_grid_icon" title="Powered"><img src={PlugSolid}></img></span>;
                }
                else if (params.data.DryPWR.toString().toUpperCase().trim() == "B") {
                    return <span className="pwr_grid_icon" title="On Battery"><img src={UnPlug}></img></span>;
                }
            }
        }
        //return '-NA-';
        return "-NA-";
    }

    static BatteryStatusFormatter(params) {
        if (params.data != null && params.data != undefined) {
            if (params.data.BatteryStatus != null && params.data.BatteryStatus != undefined) {
                if (params.data.BatteryStatus.toString().toUpperCase().trim() == "C") {
                    return <span className="pwr_grid_icon"><img src={batterycritical}></img></span>;
                }
                else if (params.data.BatteryStatus.toString().toUpperCase().trim() == "L") {
                    return <span className="pwr_grid_icon"><img src={batterylow}></img></span>;
                }
                else if (params.data.BatteryStatus.toString().toUpperCase().trim() == "N") {
                    return <span className="pwr_grid_icon"><img src={batterynormal}></img></span>;
                }                
            }
        }
        return '-NA-';
    }

    static AssetStateFormatter(params) {
        if (params.data != null && params.data != undefined) {
            //var imageElement = document.createElement("img");
            var assetState = params.data.AssetState;
            if (params.data.AssetState != null && params.data.AssetState != undefined) {
                if (assetState.toUpperCase().trim() == 'A') {
                    return <span className="ActiveRA" title="Active"><img src={AssetStateActive}></img></span>;
                }
                else if (assetState.toUpperCase().trim() == 'D') {
                    return <span className="DisconnectedRA" title="Disconnected"><img src={AssetStateDisconnected}></img></span>;
                }
                else if (assetState.toUpperCase().trim() == 'R') {
                    return <span className="RetiredRA" title="Retired"><img src={AssetStateRetired}></img></span>;
                }
            }
        }

        return '-NA-';
        //var element = document.createElement("span");

        //if (params.data != null && params.data != undefined) {
        //    var imageElement = document.createElement("img");
        //    if (params.data.AssetState != null && params.data.AssetState != undefined) {
        //        var assetState = params.data.AssetState;
        //        switch (assetState.toUpperCase().trim()) {
        //            case 'A':
        //                element.className = "ActiveRA";
        //                imageElement.src = AssetStateActive;
        //                element.title = "Active";
        //                break;
        //            case 'D':
        //                element.className = "DisconnectedRA";
        //                imageElement.src = AssetStateDisconnected;
        //                element.title = "Disconnected";
        //                break;
        //            case 'R':
        //                element.className = "RetiredRA";
        //                imageElement.src = AssetStateRetired;
        //                element.title = "Retired";
        //                break;
        //            default:
        //                break;

        //        }
        //    }

        //    element.appendChild(imageElement);
        //    return element;
        //}

        return '-NA-';
    }

    static TripstatusIndicator(params) {
        var deviationFlg = '';
        if (params.value != null && params.value != undefined && params.value != '' && params.value != '-NA-') {

            //var imageSrc = '';
            var valueString = params.value.toString();
            var arrList = valueString.split(':');
            if (arrList.length == 2) {
                var cLogStatusvalue = arrList[0];
                deviationFlg = arrList[1];
                switch (cLogStatusvalue.toUpperCase().trim()) {
                    case 'A':
                        //imageSrc = TripInprogress;
                        return <span className="reefer-alert"><img src={TripInprogress}></img></span>;
                    //break;
                    case 'C':
                        if (deviationFlg == "True")
                            //imageSrc = TripCompletedDeviation; /* WI19591 checking Trip is deviated */
                            return <span className="reefer-alert"><img src={TripCompletedDeviation}></img></span>;
                        else
                            //imageSrc = TripCompleted;
                            return <span className="reefer-alert"><img src={TripCompleted}></img></span>;
                    //break;
                    case 'D':
                        //imageSrc = TripProblemetic;
                        return <span className="reefer-alert"><img src={TripProblemetic}></img></span>;
                    //break;
                    case 'P':
                        //imageSrc = TripPending;
                        return <span className="reefer-alert"><img src={TripPending}></img></span>;
                    //break;
                    case 'R':
                        //imageSrc = TripDeleted;
                        return <span className="reefer-alert"><img src={TripDeleted}></img></span>;
                    //break;
                    case 'X':
                        if (deviationFlg == "True")
                            //imageSrc = TripCancelDeviation; /* WI19591 checking Trip is deviated */
                            return <span className="reefer-alert"><img src={TripCancelDeviation}></img></span>;
                        else
                            //imageSrc = TripCancel;
                            return <span className="reefer-alert"><img src={TripCancel}></img></span>;
                    //break;
                    default:
                        break;

                }
            }

            return <span className="reefer-alert"></span>;

        }
        return <span className="reefer-alert"></span>;
    }

    static RSSITypeFormatter(params) {
        var imageSrc = "";
        if (params.data != null && params.data != undefined) {//WI-21812:For Unknown RSSI Id image is not showing
            if (params.data.RSSI != null && params.data.RSSI != undefined) {
                if (params.data.RSSI == 0)
                    imageSrc = RSSIUNK;
                else if (params.data.RSSI <= -111)
                    imageSrc = RSSI1;
                else if (params.data.RSSI >= -110 && params.data.RSSI <= -100)
                    imageSrc = RSSI2;
                else if (params.data.RSSI >= -99 && params.data.RSSI <= -88)
                    imageSrc = RSSI3;
                else if (params.data.RSSI >= -87 && params.data.RSSI <= -76)
                    imageSrc = RSSI4;
                else if (params.data.RSSI >= -75)
                    imageSrc = RSSI5;
                else
                    imageSrc = RSSIUNK;
            }
            else
                imageSrc = RSSIUNK;//WI-21812:For Unknown RSSI Id image is not showing
        }
        return <span className="reefer-alert"><img src={imageSrc}></img></span>;

    }

    static CommentExistsFormatter(params) {

        if (params.value != null && params.value != undefined && params.value != '-NA-') {
            if (params.value == 0) {
                return <span className="Trip-edit"><img src={GroupChat}></img></span>;
            }
            else
                return "-NA-";
        }
        return "-NA-";
    }

    static GPSCoordsFormatter(params) {
        if (params.value != null && params.value != '-1000') {
            if (params.data != null && params.data != undefined && params.data != '') {
                if (params.data.DeviceType != null && params.data.DeviceType != undefined && (params.data.DeviceType.toString().toUpperCase().trim() == "GT1200" || params.data.DeviceType.toString().toUpperCase().trim() == "GT1020" || params.data.DeviceType.toString().toUpperCase().trim() == "GT1030")) {
                    if (params.value != null && params.value != '-1000')
                        return params.value;
                    else
                        return '-NA-';
                }
                else if (params.data.GPSLatitude != 0 && params.data.GPSLongitude != 0 && (params.data.GPSLockState == null || params.data.GPSLockState == '' || params.data.GPSLockState.toUpperCase() != "LOCKED")) {
                    if (params.value != null && params.value != '-1000') {
                        //params.value = <i> {params.value}</i>;
                        //params.value = <p style={"color:#736F6E"} ><i> {params.value}</i></p>;
                        var pCss = {
                            'color': '#736F6E'
                        };
                        return <p style={pCss} ><i> {params.value}</i></p>;
                    }
                    else
                        return '-NA-';
                }
                else if (params.data.GPSCoords != null && params.data.GPSCoords != undefined && params.data.GPSCoords.toString().trim() == "") {
                    return '-NA-';
                }
                else
                    return params.value;
            }
        }
        else
            return '-NA-';
    }

    static StringTypeValueFormatter(params) {
        if (params.value != "-NA-" && params.value != "" && params.value != null) {//RCNG-1357
            return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';
    }
    static PossibleDamageFormatter(params) {

        if (params.data != null && params.data != undefined) {
            if(params.value == 'Check')
                return <span className="pwr_grid_icon" title='Check'><img src={DamageCheck}></img></span>;
            else if (params.value == 'Clear')
                return <span className="pwr_grid_icon" title='Clear'><img src={clearDamage}></img></span>;
            else
                return '-NA-';
            
        }
        return '-NA-';
    }
    static PossibleDamageFormatterGrouping(param) {

        if (param != null && param != undefined) {
            if (param == 'NA') return '*No Possible Damage';
            else {
                if ( param == 'Check')
                    return <div><span className="pwr_grid_icon" title='Check'><img src={DamageCheck} ></img></span><span className='aggrid-pwr'> Check</span></div>;
                else
                    return <div><span className="pwr_grid_icon" title='Clear'><img src={clearDamage} ></img></span><span className='aggrid-pwr'> Clear</span></div>;
            }
        }
        return "*No Possible Damage"
    }

    static StringTypeFormatter(params) {
        if (params.value != null && params.value != undefined && params.value != '' && params.value != "null") {
            return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';

    }

    static StringTypeFormatterFor3P(params) {
        if (params.value != null && params.value != "null" && params.value != undefined && params.value != '' && params.value != '-NA-') {
            if (params.value === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName)
                return '-NA-';
            else
                return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';
    }

    //Grouping formatters starts here

    static TripStatusFormatterGrouping(param) {
        var deviationFlg = '';
        if (param != null && param != undefined) {
            var valueString = param.toString();
            var arrList = valueString.split(':');
            if (arrList.length == 2) {
                var cLogStatusvalue = arrList[0];
                deviationFlg = arrList[1];
                switch (cLogStatusvalue.toUpperCase().trim()) {
                    case 'A':
                        return <div><span className="reefer-alert"><img src={TripInprogress} title="In Progress"></img></span><span className='ps-1'> In Progress</span></div>;
                    case 'C':
                        if (deviationFlg == "True")
                            return <div><span className="reefer-alert"><img src={TripCompletedDeviation} title="Completed Deviation"></img></span><span className='ps-1'> Completed Deviation</span></div>;
                        else
                            return <div><span className="reefer-alert"><img src={TripCompleted} title="Completed"></img></span><span className='ps-1'> Completed</span></div>;

                    case 'D':
                        return <div><span className="reefer-alert"><img src={TripProblemetic} title="Problemetic"></img></span><span className='ps-1'> Problemetic</span></div>;
                    case 'P':
                        return <div><span className="reefer-alert"><img src={TripPending} title="Pending"></img></span><span className='ps-1'> Pending</span></div>;
                    case 'R':
                        return <div><span className="reefer-alert"><img src={TripDeleted} title="Deleted"></img></span><span className='ps-1'> Deleted</span></div>;
                    case 'X':
                        if (deviationFlg == "True")
                            return <div><span className="reefer-alert"><img src={TripCancelDeviation} title="Cancel Deviation"></img></span><span className='ps-1'> Cancel Deviation</span></div>;
                        else
                            return <div><span className="reefer-alert"><img src={TripCancel} title="Cancel"></img></span><span className='ps-1'> Cancel</span></div>;
                    default:
                        return "*No Trip";

                }
            }
            return "*No Trip";
        }
        return "*No Trip";
    }

    static RSSIFormatterGrouping(param) {
        if (param != null && param != undefined) {
            if (param == 1)
                return <div><span className="reefer-alert"><img src={RSSI5} title="5 Bars"></img></span><span className='aggrid-CellSignal'> 5 Bars</span></div>;
            else if (param == 2)
                return <div><span className="reefer-alert"><img src={RSSI4} title="4 Bars"></img></span><span className='aggrid-CellSignal'> 4 Bars</span></div>;
            else if (param == 3)
                return <div><span className="reefer-alert"><img src={RSSI3} title="3 Bars"></img></span><span className='aggrid-CellSignal'> 3 Bars</span></div>;
            else if (param == 4)
                return <div><span className="reefer-alert"><img src={RSSI2} title="2 Bars"></img></span><span className='aggrid-CellSignal'> 2 Bars</span></div>;
            else if (param == 5)
                return <div><span className="reefer-alert"><img src={RSSI1} title="1 Bar"></img></span><span className='aggrid-CellSignal'> 1 Bar</span></div>;
            else
                return <div><span className="reefer-alert"><img src={RSSIUNK} title="Unknown"></img></span><span className='aggrid-CellSignal'> Unknown</span></div>;
        }
    }

    static CommentExistsGrouping(params) {
        if (params != null && params != '-NA-') {
            if (params.toString() == "0")
                return <div><span className="reefer-alert"><img src={GroupChat} title="yes"></img></span><span className='aggrid-CellSignal'> yes</span></div>;
            else
                return "*No Comments";
        }
        else
            return '*No Comments';
    }

    static DryBatteryStatusFormatterGrouping(param) {
        if (param != null && param != undefined) {
            switch (param.toString()) {
                case "1":
                    return <div><span className="BatteryIndicator"><img src={batterycritical} title="Critical"></img></span><span className='aggrid-pwr'> Critical</span></div>;
                case "2":
                    return <div><span className="BatteryIndicator"><img src={batterylow} title="Low"></img></span><span className='aggrid-pwr'> Low</span></div>;
                case "3":
                    return <div><span className="BatteryIndicator"><img src={batterynormal} title="Normal"></img></span><span className='aggrid-pwr'> Normal</span></div>;
                case "-1":
                    return '*No BATT';
            }
        }
    }
    static AssetStateFormatterGrouping(param) {
        if (param != null && param != undefined && param != '') {
            if (param == "A") {
                return <div><span className="ActiveRA"><img src={AssetStateActive} title="Active"></img></span><span className='aggrid-Inv pl-10'> Active</span></div>;
            }
            else if (param == "D") {
                return <div><span className="DisconnectedRA"><img src={AssetStateDisconnected} title="Disconnected"></img></span><span className='aggrid-Inv'> Disconnected</span></div>;
            }
            else if (param == "R") {
                return <div><span className="RetiredRA"><img src={AssetStateRetired} title="Retired"></img></span><span className='aggrid-Inv pl-10'> Retired</span></div>;
            }
        }
        return "*No INV";
    }
    static DryPwrStateFormatterGrouping(param) {
        if (param != null && param != undefined) {
            switch (param.toString()) {
                case "1":
                    return <div><span className="PlugSolid"><img src={PlugSolid} title="Powered"></img></span><span className='aggrid-pwr'> Powered</span></div>;
                case "2":
                    return <div><span className="PlugSolid"><img src={UnPlug} title="On Battery"></img></span><span className='aggrid-pwr'> On Battery</span></div>;
                case "3":
                    return '*No PWR';
            }
        }
    }

    static DryDoorBattPctFormatterGrouping(param) {
        
        if (param != null && param != undefined) {
            if (param == "-1") return '*No Door bat';
            else {
                switch (param.toString()){
                    case "0":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP0} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "10":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP10} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "20":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP20} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "30":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP30} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "40":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP40} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "50":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP50} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "60":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP60} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "70":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP70} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "80":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP80} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "90":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP90} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                    case "100":
                        return <div><span className="BatteryIndicator" title={param.toString()}><img src={DBP100} ></img></span><span className='aggrid-pwr'> {param.toString()}</span></div>;
                }
            }
        }
    }
    static DoorBattPctFormatter(params) {
        
        if (params.data != null && params.data != undefined) {
            if (params.data.Door1BattPct != null && params.data.Door1BattPct != undefined) {
                var battPct = (Math.round(params.data.Door1BattPct / 10.0)) * 10;
                
                switch (battPct){
                    case 0:
                        return <span className="pwr_grid_icon" title={params.data.Door1BattPct}><img src={DBP0}></img></span>;
                    case 10:
                        return <span className="pwr_grid_icon" title={params.data.Door1BattPct}><img src={DBP10}></img></span>;
                    case 20:
                        return <span className="pwr_grid_icon" title={params.data.Door1BattPct}><img src={DBP20}></img></span>;
                    case 30:
                        return <span className="pwr_grid_icon" title={params.data.Door1BattPct}><img src={DBP30}></img></span>;
                    case 40:
                        return <span className="pwr_grid_icon" title={params.data.Door1BattPct}><img src={DBP40}></img></span>;
                    case 50:
                        return <span className="pwr_grid_icon" title={params.data.Door1BattPct}><img src={DBP50}></img></span>;
                    case 60:
                        return <span className="pwr_grid_icon" title={params.data.Door1BattPct}><img src={DBP60}></img></span>;
                    case 70:
                        return <span className="pwr_grid_icon" title={params.data.Door1BattPct}><img src={DBP70}></img></span>;
                    case 80:
                        return <span className="pwr_grid_icon" title={params.data.Door1BattPct}><img src={DBP80}></img></span>;
                    case 90:
                        return <span className="pwr_grid_icon" title={params.data.Door1BattPct}><img src={DBP90}></img></span>;
                    case 100:
                        return <span className="pwr_grid_icon" title={params.data.Door1BattPct}><img src={DBP100}></img></span>;
                }
            }
        }
        return '-NA-';
    }

    static BatteryPctFormatter(params) {
        
        if (params.data != null && params.data != undefined) {
            if (params.data.BatteryPct != null && params.data.BatteryPct != undefined && params.data.BatteryPct >= 0) {
                var battPct = (Math.round(params.data.BatteryPct / 10.0)) * 10;
                
                switch (battPct){
                    case 0:
                        return <span className="pwr_grid_icon" title={params.data.BatteryPct}><img src={DBP0}></img></span>;
                    case 10:
                        return <span className="pwr_grid_icon" title={params.data.BatteryPct}><img src={DBP10}></img></span>;
                    case 20:
                        return <span className="pwr_grid_icon" title={params.data.BatteryPct}><img src={DBP20}></img></span>;
                    case 30:
                        return <span className="pwr_grid_icon" title={params.data.BatteryPct}><img src={DBP30}></img></span>;
                    case 40:
                        return <span className="pwr_grid_icon" title={params.data.BatteryPct}><img src={DBP40}></img></span>;
                    case 50:
                        return <span className="pwr_grid_icon" title={params.data.BatteryPct}><img src={DBP50}></img></span>;
                    case 60:
                        return <span className="pwr_grid_icon" title={params.data.BatteryPct}><img src={DBP60}></img></span>;
                    case 70:
                        return <span className="pwr_grid_icon" title={params.data.BatteryPct}><img src={DBP70}></img></span>;
                    case 80:
                        return <span className="pwr_grid_icon" title={params.data.BatteryPct}><img src={DBP80}></img></span>;
                    case 90:
                        return <span className="pwr_grid_icon" title={params.data.BatteryPct}><img src={DBP90}></img></span>;
                    case 100:
                        return <span className="pwr_grid_icon" title={params.data.BatteryPct}><img src={DBP100}></img></span>;
                }
            }
        }
        return '-NA-';
    }
}